/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';
import BaseNode from '@appblocks/codegeneration/Nodes/BaseNode';
import NodePort from '@appblocks/codegeneration/Nodes/NodePort';
import NodeParameter from '@appblocks/codegeneration/Nodes/NodeParameter';
import PlatformUtils from '@appblocks/platforms/PlatformUtils';

export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: Array<CodeBlock> = [];
    // modbus_master_request(1, ReadCoilStatus, , 1, "", MODBUS_MASTER_INTERFACE, modbus_TCP)
    const { project } = feature;
    const ID = feature.getID();
    const DATATYPE = feature.getSettingValue('DATATYPE');
    let ADDRESS = feature.getSettingValue('ADDRESS');
    const NAME = feature.getSettingValue('NAME');
    const LENGTH = feature.getSettingValue('LENGTH');
    const DEVICE_INTERFACE = 'current_interface';
    const VARTYPE = feature.getSettingValue('VARTYPE');
    const MULTIPLIER = feature.getSettingValue('MULTIPLIER');
    let INTERFACE = 'MODBUS_MASTER_INTERFACE';
    let device;
    let DEVICENAME;
    const featureId = feature.getID();
    const parent = feature.project.getParent(feature);
    const parentId = parent.getID();
    const DEVICEID = parent.getSettingValue('DEVICEID');
    const DEVICEIP = parent.getSettingValue('DEVICEIP');
    const DEVICEPORT = parent.getSettingValue('DEVICEPORT');
    const PROTOCOL = parent.getSettingValue('PROTOCOL');
    let deviceAddress = DEVICEID;
    if (PROTOCOL === 'modbus_TCP') {
        deviceAddress = `"${DEVICEIP}:${DEVICEPORT}"`;
    }
    // convert hex to decimal for address
    if (ADDRESS.startsWith('0x')) {
        // convert hex string to decimal
        ADDRESS = parseInt(ADDRESS, 16);
    }
    const devices = project.getFeature('modbus_master').getSettingValue('MODBUSDEVICES');


    blocks.push({
        location: 'boot',
        blockType: BlockType.CODE,
        template: `
this.updateContext("${featureId}", {
    "NAME": ${NAME},
});
    `,
    });

    blocks.push({
        location: `modbus_master_request_${parentId}_registers_init`,
        blockType: BlockType.CODE,
        template: `
${ADDRESS}: "${featureId}",`,
    });

    blocks.push({
        location: `var_${NAME}_update`,
        blockType: BlockType.CODE,
        template: `
modbus_master_request(${deviceAddress}, ${DATATYPE}, ${ADDRESS});
    `,
    });

    blocks.push({
        location: `var_${NAME}_set`,
        blockType: BlockType.CODE,
        template: `
modbus_master_request(${deviceAddress}, 6, ${ADDRESS}, ${NAME});
    `,
    });

    blocks.push({
        location: 'modbus_proc_timer',
        blockType: BlockType.CODE,
        template: `
modbus_master_request(${deviceAddress}, ${DATATYPE}, ${ADDRESS});
    `,
    });

    blocks.push({
        location: 'callback_modbus_slave_reply',
        blockType: BlockType.CODE,
        template: `
if (device_id === ${deviceAddress} && register_address === ${ADDRESS}) {
    var_${NAME}_update_completed(response_data * ${MULTIPLIER});
}
    `,
    });

    return blocks;
};
